import { Component, Input } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-files",
	templateUrl: "./asset-files.component.html",
	styleUrls: ["./asset-files.component.scss"],
	imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class AssetFilesComponent {
	@Input()
	asset: APIResults.Asset;
}
